import React from 'react';
import { Alert, Button, CircularProgress, Stack } from '@mui/material';
import { useFormikContext } from 'formik';
import { FolioDrawerFooter } from '@/components/Drawers/FolioDrawer/FolioDrawerFooter';

/**
 * The sticky Cancel and Save bar at the bottom of the client config page, as on the CRM
 * forms. Both wait for a change, and a "You have unsaved changes." warning shows above them
 * while there is one. Cancel throws the changes away.
 */
export const FormFieldConfigsFooter = () => {
	const { dirty, isSubmitting, submitForm, resetForm } = useFormikContext();

	return (
		<FolioDrawerFooter>
			<Stack spacing={1} alignItems='center' sx={{ width: '100%' }}>
				{dirty && (
					<Alert
						severity='warning'
						sx={{
							width: '100%',
							py: 0,
							'& .MuiAlert-icon, & .MuiAlert-message': { py: 0.25 },
						}}
					>
						You have unsaved changes.
					</Alert>
				)}
				<Stack direction='row' spacing={1}>
					<Button
						variant='outlined'
						disabled={!dirty || isSubmitting}
						onClick={() => resetForm()}
					>
						Cancel
					</Button>
					<Button variant='contained' disabled={!dirty || isSubmitting} onClick={submitForm}>
						{isSubmitting ? (
							<CircularProgress size='2em' sx={{ color: '#ffffff' }} />
						) : (
							'Save'
						)}
					</Button>
				</Stack>
			</Stack>
		</FolioDrawerFooter>
	);
};

FormFieldConfigsFooter.displayName = 'FormFieldConfigsFooter';
